<template>
  <div class="c-products">
    <h2
      class="c-products__title"
      v-if="title"
    >
      {{ title }}
    </h2>
    <router-link
      :to="product.link ? product.link : '/'"
      class="c-product"
      v-for="product in products"
      :key="product.label"
    >
      <div class="c-product__icon">
        <o-icon
          :icon="product.icon"
          :keep-colors="product.keepColors"
        />
      </div>
      <div class="c-product__label">{{ product.label }}</div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'OProductList',
  props: {
    title: {
      type: String,
      default: null
    },
    products: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
.c-products {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 0 0 1.6rem 0;
}

.c-products__title {
  display: block;
  flex: none;
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0.8rem 0 1.6rem;
  position: relative;
  text-align: center;
  text-shadow: 0.1rem 0rem 0 $primary-color, -0.1rem 0rem 0 $primary-color
    0.2rem 0rem 0 var(--primary-color), -0.2rem 0rem 0 $primary-color,
    0.3rem 0rem 0 var(--primary-color), -0.3rem 0rem 0 $primary-color,
    0.4rem 0rem 0 var(--primary-color), -0.4rem 0rem 0 $primary-color
    0.5rem 0rem 0 var(--primary-color), -0.5rem 0rem 0 $primary-color;;
  text-shadow: 0.1rem 0rem 0 var(--primary-color), -0.1rem 0rem 0 var(--primary-color),
    0.2rem 0rem 0 var(--primary-color), -0.2rem 0rem 0 var(--primary-color),
    0.3rem 0rem 0 var(--primary-color), -0.3rem 0rem 0 var(--primary-color),
    0.4rem 0rem 0 var(--primary-color), -0.4rem 0rem 0 var(--primary-color),
    0.5rem 0rem 0 var(--primary-color), -0.5rem 0rem 0 var(--primary-color);
  text-transform: uppercase;
  width: 100%;

  &:before {
    background: rgba(#FFF, 0.2);
    content: '';
    height: 0.1rem;
    left: 0;
    position: absolute;
    top: 50%;
    width: 100%;
    z-index: -1;
  }
}

.c-product {
  display: flex;
  flex: 1 0 12rem;
  flex-direction: column;
  align-items: center;
  padding: 1.6rem 0.8rem 1.2rem;
}

.c-product__icon {
  background: #fff;
  border-radius: 2.8rem;
  box-shadow: $box-shadow;
  color: $primary-color;
  color: var(--primary-color);
  display: flex;
  padding: 1.2rem;
}

.c-product__label {
  font-size: 1.3rem;
  font-weight: 600;
  margin-top: 0.8rem;
  text-align: center;
}
</style>
